"use client";
import { Controller, useFormContext } from "react-hook-form";
import { Box } from "@mui/material";
import { StyledTextField } from "./StyleInputs";
import { parseNumber } from "utils/formUtils";

const TextFieldComponent = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const $errorMessage = errors[field.id]?.message;
  const customErrorMessage = field.validation?.errorMessage;
  const errorMessage = $errorMessage
    ? customErrorMessage || $errorMessage
    : undefined;

  return (
    <Box sx={{ mb: 3 }}>
      <Controller
        name={field.id}
        control={control}
        defaultValue=""
        rules={{
          required: field.required ? `${field.label} is required` : false,
          ...(field?.validation?.min
            ? {
                minLength: parseNumber(field.validation.min),
              }
            : {}),
          ...(field?.validation?.max
            ? {
                maxLength: parseNumber(field.validation.max),
              }
            : {}),
          pattern: field.validation?.regex
            ? {
                value: new RegExp(field.validation.regex),
                message: field.validation.errorMessage || "Invalid format",
              }
            : undefined,
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            fullWidth
            placeholder={field.placeholder}
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            required={field.required}
            label={field.label}
          />
        )}
      />
    </Box>
  );
};

export default TextFieldComponent;
